import { FlexColumn, FlexMiddle } from '@ubeya/shared-web/components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import React, { useContext, useState } from 'react';
import { ReactComponent as Pencil } from '@ubeya/shared-web/assets/edit.svg';
import styled from 'styled-components';
import withPermissions from '@ubeya/shared-web/hoc/withPermissions';
import privileges from '@ubeya/shared-web/privileges';
import { contractTypeToTranslationKey } from '@ubeya/shared/constants';
import ContractAssignModal from './ContractAssignModal';

const Container = styled(FlexColumn)`
  gap: 4px;
`;
const Label = styled.label`
  color: ${({ theme }) => theme.colors.grey4};
`;
const Box = styled(FlexMiddle)`
  cursor: ${({ $isEdit }) => ($isEdit ? 'pointer' : 'default')};
  justify-content: space-between;
  border: 1px solid ${({ theme }) => theme.colors.disabled};
  border-radius: 4px;
  padding: 10px;
`;

const EmployeeContractAssign = ({
  activeContract,
  accountContracts,
  assignContract,
  userPermissions: { hasActionPermission }
}) => {
  const { t } = useContext(ConfigContext);
  const [showAssignContractModal, setShowAssignContractModal] = useState(false);

  const title = activeContract
    ? `${activeContract.name} / ${t(contractTypeToTranslationKey[activeContract.type] || '')}`
    : t('pleaseSelect');

  return (
    <>
      <Container>
        <Label>{t('contractTypes_assignedContract')}</Label>
        <Box $isEdit={hasActionPermission} onClick={() => hasActionPermission && setShowAssignContractModal(true)}>
          <p>{title}</p>
          {hasActionPermission && <Pencil />}
        </Box>
      </Container>

      {showAssignContractModal && (
        <ContractAssignModal
          onClose={() => setShowAssignContractModal(false)}
          activeContract={activeContract}
          assignContract={assignContract}
          accountContracts={accountContracts}
        />
      )}
    </>
  );
};

export default withPermissions(React.memo(EmployeeContractAssign), {
  action: { privileges: [privileges.MANAGE_EMPLOYEE_HOLIDAY_ACCRUAL] }
});
